import { Link } from "react-router-dom";
import { Phone, Mail, Clock } from "lucide-react";

const LOGO = "/logo-badge.png";

export default function Footer() {
  return (
    <footer className="bg-[#23282B] text-white pt-20 pb-10 border-t-4 border-[#9CC4DB]" data-testid="site-footer">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 lg:px-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div>
          <img src={LOGO} alt="Amazing View Contracting" className="h-20 w-auto block" />
          <div className="text-[#9CC4DB] text-xs font-bold tracking-[0.25em] uppercase mt-4">Amazing is What<br/>We Thrive For.</div>
          <p className="mt-4 text-sm text-white/70 leading-relaxed">
            Excavation, concrete and site work — residential through heavy civil and commercial — serving Vancouver Island and the Lower Mainland of British Columbia.
          </p>
        </div>
        <div>
          <div className="font-display text-lg tracking-[0.15em] text-white uppercase">Explore</div>
          <div className="w-8 h-0.5 bg-[#9CC4DB] mt-2" />
          <ul className="mt-4 space-y-2 text-sm">
            <li><Link to="/services" className="text-white/80 hover:text-[#9CC4DB] transition-colors">Services</Link></li>
            <li><Link to="/past-jobs" className="text-white/80 hover:text-[#9CC4DB] transition-colors">Past Jobs</Link></li>
            <li><Link to="/guide" className="text-white/80 hover:text-[#9CC4DB] transition-colors">Homeowner's Guide</Link></li>
            <li><Link to="/blog" className="text-white/80 hover:text-[#9CC4DB] transition-colors">Blog</Link></li>
            <li><Link to="/about" className="text-white/80 hover:text-[#9CC4DB] transition-colors">About</Link></li>
            <li><Link to="/qa" className="text-white/80 hover:text-[#9CC4DB] transition-colors">Q&A</Link></li>
            <li><Link to="/contact" className="text-white/80 hover:text-[#9CC4DB] transition-colors">Get a Quote</Link></li>
          </ul>
        </div>
        <div>
          <div className="font-display text-lg tracking-[0.15em] text-white uppercase">Contact</div>
          <div className="w-8 h-0.5 bg-[#9CC4DB] mt-2" />
          <ul className="mt-4 space-y-3 text-sm text-white/80">
            <li><a href="tel:+12508861112" data-testid="footer-phone" className="flex items-start gap-2 hover:text-[#9CC4DB] transition-colors"><Phone size={16} className="mt-0.5 text-[#9CC4DB]" /> (250) 886-1112</a></li>
            <li><a href="mailto:char@amazingviewcontracting.com" data-testid="footer-email" className="flex items-start gap-2 hover:text-[#9CC4DB] transition-colors break-all"><Mail size={16} className="mt-0.5 text-[#9CC4DB] shrink-0" /> char@amazingviewcontracting.com</a></li>
            <li className="text-white/60 text-xs tracking-widest uppercase pt-2">Serving Vancouver Island<br/>& the Lower Mainland</li>
          </ul>
        </div>
        <div>
          <div className="font-display text-lg tracking-[0.15em] text-white uppercase">Hours</div>
          <div className="w-8 h-0.5 bg-[#9CC4DB] mt-2" />
          <ul className="mt-4 space-y-2 text-sm text-white/80">
            <li className="flex items-start gap-2"><Clock size={16} className="mt-0.5 text-[#9CC4DB]" /> Mon–Fri · 7 AM – 5 PM</li>
            <li className="pl-6">Sat · By appointment</li>
            <li className="pl-6">Sun · Closed</li>
          </ul>
          <Link to="/contact" data-testid="footer-quote-cta" className="mt-5 inline-flex items-center bg-[#2F5F80] hover:bg-[#234B66] text-white text-xs font-bold tracking-[0.15em] px-5 py-3 uppercase transition-colors">
            Get a Free Quote
          </Link>
        </div>
      </div>
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 lg:px-16 mt-12 pt-6 border-t border-white/10 flex flex-col md:flex-row gap-3 justify-between text-xs text-white/50 tracking-widest uppercase">
        <div>© {new Date().getFullYear()} Amazing View Contracting Ltd.</div>
        <div className="flex gap-4">
          <span>BC, Canada</span>
          <span>Licensed · Insured</span>
        </div>
      </div>
    </footer>
  );
}
